<template>
	<div>
		<headdv ></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<headdv2 @tapAddFun="addManager" @SearchFun="SearchFun" @allDelFun="allDelFun"  @condition1="condition1" :headData="headData"></headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="60"></el-table-column>
						<el-table-column prop="hs_id" label="ID" min-width="80"></el-table-column>
						<el-table-column prop="hs_status" label="状态" min-width="180" :formatter="formatter_hs_status"></el-table-column>
						<el-table-column prop="hs_name" label="关键词" min-width="180"></el-table-column>
						<el-table-column prop="hs_click" label="点击数" min-width="180"></el-table-column>
						<el-table-column prop="hs_addtime" label="添加时间" min-width="160" :formatter="formatter_time"></el-table-column>
						<el-table-column label="操作"  width="160">
							<template slot-scope="scope">
								<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)">编辑</el-button>
								<el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
            <page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="650px" class="dialog" :close-on-click-modal='false'>
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="100px">
				<el-form-item label="状态:" prop="hs_status">
					<el-switch v-model="staffForm.hs_status" inactive-text="禁用" active-text="正常" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
				<el-form-item label="关键词:" prop="hs_name">
					<el-input v-model="staffForm.hs_name" placeholder="请输入关键词"></el-input>
				</el-form-item>
				<el-form-item label="点击数:" prop="hs_click">
					<el-input v-model="staffForm.hs_click" placeholder="请输入点击数"></el-input>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 批量修改 -->
		<el-dialog :visible.sync="statusVisible" width="650px" class="dialog" :close-on-click-modal='false'>
			<div class="dialog-title" slot="title">批量修改用户状态</div>
			<!-- 内容区 start-->
			<el-form   label-width="100px">
				<el-form-item label="用户状态：" prop="u_status">
					<el-switch v-model="u_status" inactive-text="禁用" active-text="正常" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusVisible=false">取 消</el-button>
				<el-button type="primary" @click="updataStatus()">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog" :close-on-click-modal='false'>
			<div class="dialog-title" slot="title">删除</div>
			<span>确定删除?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			headData:{
				//search_placeholder:'请输入用户名用户手机',
				title:'后台账号列表',
				add:true,
				search:false,
				del:true,
				condition1:true,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			multipleSelection: [],      //操作多选的数据---   左边勾选的框都会显示在这个数组中
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			accountList: [], //列表数据
			dialogVisible: false,   //开启验证
			isEditOrAdd: false,     //判断是添加还是编辑，true为编辑/false为添加
         //修改编辑的数据
			staffForm: {
				hs_id:'',
				hs_status: "",
				hs_click: "",
				hs_name: "",
			},
			searchVal:'',  //搜索
			//验证规则
			rules: {
				hs_name: [{ required: true, message: "请输入关键词", trigger: "blur" },],
				hs_click: [{ required: true, message: "请输入点击数", trigger: "blur" }],
			},
			statusVisible:false, //批量修改的显示状态
			u_status:0, //批量修改值
		};
	},
	created() {
		this.getclasslist();
	},
	methods: {
		//批量修改状态  保存
		updataStatus(){
			let ids = ''
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				if(ids == ''){
					ids = this.multipleSelection[i].hs_id
				}else{
					ids = ids + ',' + this.multipleSelection[i].hs_id
				}
			}
			let fromData = {
				hs_id:ids,
				hs_status:this.u_status,
			}
			this.https(this.apiList.updateHotSearch, fromData).then(
				(response) => {
				if (response.data.code == this.common.code){
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "批量修改");
				}
				this.statusVisible = false; //隐藏提示框
				}
			);
		},
		//格式化内容--时间
		formatter_time(row, column, cellValue, index) {
		let time = this.gettime.format(cellValue*1000,3) 
		return time;
		},
		//格式化内容--状态 0禁用 1正常
		formatter_hs_status(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "正常";
			} else {
					return "禁用";
			}
		},
		
		//获取列表数据--用户列表
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&key=${this.searchVal}`;
			this.https(this.apiList.getHotSearchList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
               this.accountList = response.data.data.rows; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
				}
			});
		},
		// 点击添加按钮
		addManager() {
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key !='hs_id'){
					fromData[key] = this.staffForm[key]
				}
			}	
			this.https(this.apiList.addHotSearch, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					for(let key in this.staffForm){
						if(key == 'hs_status' ) {
							this.staffForm[key] = 0
						}else {
							this.staffForm[key] = ''
						}
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}	
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			console.log(2222)
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}	
			this.https(this.apiList.updateHotSearch,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.hs_id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick() {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].hs_id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				hs_id : this.delarr[0],
			}
			this.https(this.apiList.deleteHotSearch, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		

		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
				this.searchVal = data
				this.getclasslist();
        },
        //批量删除
        allDelFun(){
			if(this.multipleSelection.length == 0 ){
				this.$message({message: '请选择要删除的数据！',type: 'warning'});
				return false
			}
			this.AllDeleteClick() 
        },
        //条件筛选1
        condition1(){
			if(this.multipleSelection.length == 0 ){
				this.$message({message: '请选择要复制的数据！',type: 'warning'});
				return false
			} 
            this.u_status = 0
			this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选3
        condition3(){
            console.log('condition3')
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
        },
        //分页
			//pageSize 改变时会触发    每页条数
			handleSizeChange(val) {
				console.log(val)
				this.pageData.pagesize = val 
				this.getclasslist();
			},
			//currentPage 改变时会触发     当前页
			handleCurrentChange(val) {
				console.log(val)
				this.pageData.pageindex = val
				this.getclasslist();
			},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
			//操作多选  --获取多选的内容
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
	},
};
</script>
<style lang="scss" scoped>

// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>